// tslint:disable: no-invalid-template-strings
import { ActionType, createAction } from "typesafe-actions";
import { IListObjectStore } from "../../_common/type";
import {
	EORB3RecordCode,
	TORB3BackendRecord,
	TORB3HistoryFilters,
} from "./@types";

enum EORB3Constants {
	FEATURE = "@orb-3",
	// API = '/marpol-oil-record-book3',
	API = "/api/marpol/all",
}
enum EORB3Actions {
	HISTORY_LOAD = "@orb-3/:history-load",

	HISTORY_SET = "@orb-3/${history}/set",

	GOTO_DASHBOARD = "@orb3/-->dashboard",
	GOTO_OPERATION_DASHBOARD = "@orb3/-->operation-dashboard",
	GOTO_SELECTED_OPERATION = "@orb3/-->selected-operation",
	GOTO_HISTORY = "@orb3/-->history",

	SET_FILTER = "@orb3/:set-filter",
}

const orb3Actions = {
	commands: {
		historyLoad: createAction(
			EORB3Actions.HISTORY_LOAD,
			(providedFilters: TORB3HistoryFilters) => ({ providedFilters }),
		)(),
	},
	document: {
		historySet: createAction(
			EORB3Actions.HISTORY_SET,
			(history: IListObjectStore<TORB3BackendRecord>) => ({ history }),
		)(),
		setFilter: createAction(EORB3Actions.SET_FILTER, (filter: any) => ({
			filter,
		}))(),
	},
	routes: {
		gotoDashboard: createAction(EORB3Actions.GOTO_DASHBOARD)(),
		gotoOperationDashboard: createAction(
			EORB3Actions.GOTO_OPERATION_DASHBOARD,
		)(),
		gotoSelectedOperation: createAction(
			EORB3Actions.GOTO_SELECTED_OPERATION,
			(operationCode: EORB3RecordCode) => ({ operationCode }),
		)(),
		gotoHistory: createAction(EORB3Actions.GOTO_HISTORY)(),
	},
	events: {},
};

export type TORB3Actions = ActionType<typeof orb3Actions>;
export default orb3Actions;
export { EORB3Constants, EORB3Actions };
